import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const deleteGroupingMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Delete grouping',
		isVisible: ({ controller }): boolean => {
			return !controller.readonly;
		},
		onClick: ({ refMap }): void => {
			if (refMap?.panelItemGroup) {
				// Delete all items in the group (triggers purgeEmpty to remove the group itself)
				const itemIds = refMap.panelItemGroup.items.children.map((pi) => pi.id);
				itemIds.forEach((id) => { refMap.panelItemGroup.items.delete(id); });
			}
		}
	};
};
